import { AsgardFeatureNames } from "src/models/AsgardFeatures";

export enum DictionaryType {
    Translation = 0,
    Explanatory = 1,
    Picture = 2,
    VerbForms = 3
}

export enum LookupDialogType {
    Text = 0,
    Picture = 1,
    Conjugations = 2,
    Synonyms = 3
}

export interface ILanguageModel {
    id: number;
    name: string;
    code: string;
}

export interface IDictionaryModel {
    id: number;
    type: DictionaryType;
    name: string;
}

export interface ISettingsDictionaryViewModel extends IDictionaryModel {
    selected: boolean;
}

export interface ITextDictionaryModel extends IDictionaryModel {
    sourceLanguage: ILanguageModel;
    destinationLanguage: ILanguageModel;
}

export interface IPictureDictionaryModel extends IDictionaryModel {
    sourceLanguage: ILanguageModel;
}

export interface IVerbFormModel extends IDictionaryModel {
    parentTag: string;
    childTag: string;
    descriptionHTML: string;
    language: ILanguageModel;
  }

export interface IDictionaryWordModel {
    dictionaryId: number;
    dictionaryName: string;
    html: string;
    destinationLanguage: ILanguageModel;
}

export interface IPictureWordModel {
    word: string;
    path: string;
    dictionary: string;
    type: string;
}

export interface IHomophoneWordModel {
    word: string;
}

export interface ITab {
    key: string;
    class: string;
    isActive: boolean;
    supportHmp: boolean;
    lookupType: LookupDialogType;
    feature?: AsgardFeatureNames;
  }

export const dictResponseCls = 'dict-area';

export const tabs: ITab[] = [
    {
      key: 'LOOKUP.DICTIONARY.TABTITLE', class: 'fas fa-book-open', isActive: true,
      supportHmp: true, lookupType: LookupDialogType.Text,
      feature: AsgardFeatureNames.DICTIONARY
    },
    {
      key: 'LOOKUP.PICTUREDICT.TABTITLE', class: 'fas fa-images', isActive: false,
      supportHmp: true, lookupType: LookupDialogType.Picture,
      feature: AsgardFeatureNames.IMAGE_DICTIONARY
    },
    {
      key: 'LOOKUP.CONJUGATION.TABTITLE', class: 'fas fa-list-ul', isActive: false,
      supportHmp: false, lookupType: LookupDialogType.Conjugations,
      feature: AsgardFeatureNames.CONJUGATIONS
    },
  ];
